import React from "react";
import Layout from "components/layout";
import Block1 from "./bannerSingleLang";
import Block2 from "./secondFrench";
import SEO from "components/seo";
import Reviews from "components/Reviews";
import { reviewsData } from "components/Reviews/config";
import Block3 from "./thirdFrench";
import Block4 from "./contentDynamic";
import BottomLogoPanel from "./bottomLogoPanel";
import GetInTouch from "components/getInTouch";

const LanguageDynamicPage = (props) => {
  const pageData = props.pageContext.data;
  return (
    <Layout>
      <SEO
        title={pageData.meta.meta_title}
        description={pageData.meta.meta_description}
        keywords={pageData.meta.meta_keywords}
        slug={pageData.slug}
      />
      {pageData.widgets &&
        pageData.widgets.map(({ widget, data }, i) => {
          if (widget === "block_1") {
            return (
              <div key={i}>
                <Block1 data={data} />
              </div>
            );
          } else if (widget === "block_2") {
            return (
              <div key={i}>
                <Block2 data={data} />
              </div>
            );
          } else if (widget === "block_3") {
            return (
              <div key={i}>
                <Block3 data={data} />
              </div>
            );
          } else if (widget === "block_4") {
            return (
              <div key={i}>
                <Block4 data={data} />
              </div>
            );
          } else if (widget === "block_7") {
            return (
              <div key={i}>
                <Reviews data={reviewsData} />
              </div>
            );
          }
          return false;
        })}
      <BottomLogoPanel />
      <GetInTouch />
    </Layout>
  );
};
export default LanguageDynamicPage;
